import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";

class ExpenseTable extends Component {
  columns = [
    {
      path: "payment_date",
      label: "Payment Date",
      width: "2",
    },
    {
      path: "description",
      label: "Description",
      width: "6",
    },
    {
      path: "expense_type_id.name",
      label: "Expense Type",
      width: "3",
    },
    {
      path: "cost",
      label: "Amount",
      width: "2",
    },
    {
      path: "attachment",
      label: "File",
      width: "1",
      content: (type) =>
        type.attachment == "" ? (
          <a
            className="ui"
            style={{
              backgroundColor: "red",
              color: "white",
              paddingLeft: "14px",
              height: "8px",
            }}
            href={"/expenses/" + type.id + "/edit"}
          >
            &nbsp;
          </a>
        ) : (
          <a
            className="ui"
            style={{
              backgroundColor: "green",
              color: "white",
              paddingLeft: "14px",
              height: "8px",
            }}
            href={
              process.env.REACT_APP_BACKEND_URL + "/storage/" + type.attachment
            }
          >
            &nbsp;
          </a>
        ),
    },

    {
      key: "actions",
      width: "2",
      content: (type) => (
        <div>
          <React.Fragment>
            {auth.getCurrentUser().email ===
              "company-unblocker@gondalgroup.ae" && (
              <Icon
                name="trash"
                color="red"
                className="clickable"
                onClick={() => this.props.onDelete(type)}
              />
            )}
            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </React.Fragment>
        </div>
      ),
    },
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default ExpenseTable;
